/* ログ一覧画面 */
import React, { useState } from 'react';
import { render } from 'react-dom';
import { Button, Col, Container, Row } from 'react-bootstrap';
import LogResultList from '../../molecules/LogResultList';
import LogSearchForm from '../../organisms/LogSearchForm';
import axios from '../../axios';
import LoadingModal from '../../molecules/LoadingModal';

const LogList: React.FC = () => {
  const [log_list, setLogList] = useState([]);
  const [is_loading, setIsLoading] = useState(false);
  const config = {
    display_list_number: [10, 50, 100, 500, 1000],
  };

  // 「検索」ボタン押下時
  const handleClickSearch = async (params: Object) => {
    try {
      setIsLoading(true);
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/debug/log_list/search`,
        params
      );
      setLogList(response.data.detail.logs);
    } catch (error) {
      error.response.data.message.forEach((message: string) => console.log(message));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Container id="log">
        <Row>
          <Col as="h3">ログ一覧</Col>
        </Row>
        <LogSearchForm handleClickSearch={handleClickSearch} />
        <LogResultList projects={log_list} config={config} />
        <div className="d-flex justify-content-center">
          <Button
            variant="outline-success"
            href={`${location.origin}${process.env.MIX_MOCK_URL}/debug`}
          >
            メニューに戻る
          </Button>
        </div>
      </Container>
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('log-list')) {
  render(<LogList />, document.getElementById('log-list'));
}
